const doc = [({"ja":({"adminConstantMessageType":({"text":"テキスト", "image":"画像", "externalImage":"外部画像", "quickReply":"クイックリプライ", "button":"ボタン", "carousels":"カルーセル"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;